import React from "react";

const NewsArticle = ({ title, date, author, image, content }) => {
  return (
      <div className="row p-2 justify-content-center">
        <div className="col-xs-12 col-md-8 col-lg-6">
          {/* Breadcrumb */}
          <nav aria-label="" className="mb-4">
            <a href="/" className="text-muted text-decoration-none">
            Home /
            </a>
            <a href="/news" className="text-muted text-decoration-none"> News</a> 
          </nav>

          {/* Article Title */}
            <h1 className='myheadingnews' style={{color: "#5F259F"}}>
              {title}
            </h1>
          <hr></hr>
          {/* Date and Author */}
          <div className="mb-4">
            <span className="text-muted" style={{ fontSize: '1rem' }}>
              {date} | {author}
            </span>
          </div>

          {/* Article Image */}
          <div className="mb-4">
            <img 
              src={image} 
              alt={title}
              className="img-fluid w-100 rounded"
              style={{ 
                height: '450px', 
                objectFit: 'cover',
                borderRadius: '15px'
              }}
            />
          </div>

          {/* Article Content */}
          <div className="row justify-content-center">
            <div className="col-12">
              <div className="article-content" style={{ 
                fontSize: '1.1rem', 
                lineHeight: '1.8',
                color: '#666666'
              }}>
                <div dangerouslySetInnerHTML={{ __html: content }}></div>
              </div>
            </div>
          </div>
        </div>
      </div>
  );
};

export default NewsArticle;


// WEBPACK FOOTER //
// src/components/NewsComponents/NewsArticle.js